// extracted by mini-css-extract-plugin
export default {"title":"StaticPageList_title__SjGqv","list":"StaticPageList_list__RM55n","listItem":"StaticPageList_listItem__e4K6S","listItemText":"StaticPageList_listItemText__wms42"};